import { map, ifElse, always, isNil, pipe, equals, F, curry, match, head, replace, applySpec, defaultTo } from 'ramda';

export const LINK_CONTENT_ID = /:[A-z0-9]+\)/g;
export const LINK_URL = /:(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?\)/g;
// eslint-disable-next-line
export const LINK = /\[.+?\]\([A-z]+:([A-z0-9]+|((http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?))\)/g;
export const LINK_TEXT = /\[.+\]/g;
export const LINK_CONTENT_TYPE = /\([A-z]+:/g;
export const SQUARE_BRACKET = /(\[)|(\])/g;
export const ROUND_BRACKET = /(\()|(\))/g;
export const COLON = ':';

const STANDARD_LINK_URL = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/g;
const EXTERNAL_LINK_TYPE = 'external';

export const isExternalLink = equals(EXTERNAL_LINK_TYPE);

export const isExternalTypeLink = link => match(STANDARD_LINK_URL, link);

export const getLinks = text => text.match(LINK);

export const getText = link => link.match(LINK_TEXT)[0].replace(SQUARE_BRACKET, '');

export const getContent = curry((pattern, link) =>
  pipe(
    defaultTo(''),
    match(pattern),
    head,
    replace(COLON, ''),
    replace(ROUND_BRACKET, '')
  )(link)
);

export const getExternalUrl = link =>
  pipe(
    (val = '') => val.match(LINK_URL),
    ifElse(isNil, F, val => val[0].replace(COLON, '').replace(ROUND_BRACKET, ''))
  )(link);

export const getNavigationParam = ifElse(
  pipe(
    getContent(LINK_CONTENT_TYPE),
    isExternalLink
  ),
  getExternalUrl,
  getContent(LINK_CONTENT_ID)
);

export const getLinkParams = applySpec({
  text: getText,
  contentType: getContent(LINK_CONTENT_TYPE),
  navigationParam: getNavigationParam,
});

export const getLinksMap = pipe(
  defaultTo(''),
  getLinks,
  ifElse(isNil, always([]), map(raw => ({ raw, params: getLinkParams(raw) })))
);
